import type { AnchorHTMLAttributes, HTMLAttributes, ReactNode } from "react";
import { suite } from "@perprotocol/catalog";

function classes(base: string, className?: string) {
  return className ? `${base} ${className}` : base;
}

export interface PerProtocolLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  label?: ReactNode;
}

export function PerProtocolLink({ className, href = suite.url, label = suite.name, ...props }: PerProtocolLinkProps) {
  return <a className={classes("pp-suite-link", className)} href={href} {...props}>{label}</a>;
}

export interface ProductBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export function ProductBadge({ className, children, ...props }: ProductBadgeProps) {
  return <span className={classes("pp-product-badge", className)} {...props}>{children}</span>;
}

export function VisuallyHidden({ className, children, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={classes("pp-visually-hidden", className)} {...props}>{children}</span>;
}

